var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12C17.7426 12 18.75 10.9926 18.75 9.75V8.25C18.75 7.00736 17.7426 6 16.5 6H7.5C6.25736 6 5.25 7.00736 5.25 8.25V9.75C5.25 10.9926 6.25736 12 7.5 12M16.5 12H7.5M16.5 12C17.7426 12 18.75 13.0074 18.75 14.25V15.75C18.75 16.9926 17.7426 18 16.5 18H7.5C6.25736 18 5.25 16.9926 5.25 15.75V14.25C5.25 13.0074 6.25736 12 7.5 12M8.25 9V9.0075M8.25 15V15.0075M11.25 9H15.75M11.25 15H15.75",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.68b979189438a22fc8a927db508cd752.svg";
export { ForwardRef as ReactComponent };